// https://www.veryicon.com/icons/miscellaneous/indata/walking-1.html

import React, { useState } from 'react';
import { Container, Grid } from '@mui/material';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import DataFilter from './components/filter';
import { useDispatch } from '../../../redux/store';
import DashboardStatBox from './components/DashboardStatBox';
import { fCurrency } from '../../../utils/formatNumber';
import SalesCountIcon from './components/icons/salesCountIcon';
import { accessVerify } from '../../../utils/common';

export default function HomeDashboard() {
  const dispatch = useDispatch();
  const { themeStretch } = useSettings();
  const [data, setData] = useState([]);

  return (
    <Page title='General: Banking'>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={3}>
          <DataFilter data={data} setData={setData} />

          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Number Of Cards Linked' value={data?.cardLinkedCheckIns?.[0]?.count} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Number of Ingredients' value={data?.stockTypeCounts?.find(value=> value?.type === 'ingredient')?.count} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Cost of Ingredients' value={fCurrency(data?.stockTypeCounts?.find(value=> value?.type === 'ingredient')?.cost)} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Number of Menu' value={data?.stockTypeCounts?.find(value=> value?.type === 'menu')?.count} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Number Of Cards Available' value={data?.totalCardCount?.[0]?.count} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Total Number of Checkins' value={data?.totalCheckins?.[0]?.count} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Total Payments Received' value={fCurrency(data?.totalPayments?.[0]?.totalAmount)} icon={<SalesCountIcon />} />}
          </Grid>
          <Grid item xs={12} md={6}>
            {accessVerify('DASHBOARD_ANALYTICS_PAGE') && <DashboardStatBox title='Total Sold Amount' value={fCurrency(data?.totalSaleAmount?.[0]?.totalAmount)} icon={<SalesCountIcon />} />}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
